import Styles from './PostPreviewModal.module.scss'
import { IntegrationPicker } from './IntegrationPicker'
import { DateTimePicker } from 'blaze-ui/DateTimePicker/DateTimePicker'
import { usePostPreviewContext } from './PostPreviewContext'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { ReminderButtons } from './ReminderButtons'

export const ReminderDetails = () => {
  const { scheduledPost, providerName, provider, dateTime, setDateTime } = usePostPreviewContext()

  if (!scheduledPost || !provider || !providerName) return null

  return (
    <div className={Styles.integrationContainer}>
      <div className={Styles.postDetails}>
        <IntegrationPicker scheduledPost={scheduledPost} provider={provider} providerName={providerName} />
        <DateTimePicker dateTime={dateTime} setDateTime={setDateTime} responsive inline />
        <ResponsiveDesign.Desktop>
          <ReminderButtons />
        </ResponsiveDesign.Desktop>
      </div>
    </div>
  )
}
